import React,{useState} from 'react'
import {  useParams,useLocation } from 'react-router-dom'
import ProductList from '../components/Content/ProductList'
import {useProductRequests} from '../helpers/ProductRequests'
import { Helmet } from 'react-helmet'

export default function Search(props) {

  const {slug,filter} = useParams()
  const [products,setProducts]=useState([])
  const [allData,setAllData]=useState(null)
  const [sort,setSort]=useState({sort:"DATE",sortedBy:"DESC",name:"Yeni Ürünler"})
  const [selectedBrand,setSelectedBrand]=useState(slug)
  const [search,setSearch]=useState(filter)
  const {getProducts}=useProductRequests()
  
  const simpleCount=20
  
  const getNewProducts=async(newpage,setLoading,setPage)=>{
    setLoading(true)
    getProducts({brandSlug:selectedBrand,count:10,groupSlug:slug,page:newpage,all:search})
    .then(async response=>{
      if(response.data.data.items && response.data.data.items.length<1){
        setLoading(false)
      }else{
        setProducts([...products,...response.data.data.items])
      }
    })
  }
  const getSearchedProducts=(setLoading,setPage)=>{
    setLoading(true)
    getProducts({brandSlug:selectedBrand,count:10,groupSlug:slug,page:1,all:search})
    .then(response=>{
      if(response.data.data.items && response.data.data.items.length<1){
        setLoading(false)
      }else{
        setPage(2)
        setProducts(response.data.data.items)
      }
    })
  }
  React.useEffect(()=>{
    setSearch(filter)
  },[filter])
  return (
    <>
    <Helmet>
      <title>Ürün Listesi</title>
    </Helmet>
    <ProductList
    setSelectedBrand={setSelectedBrand} selectedBrand={selectedBrand}
    slug={slug}
    getNewProducts={getNewProducts}
    getSearchedProducts={getSearchedProducts}
    products={products}
    search={search}
    setSearch={setSearch}
    setProducts={setProducts}
    getProducts={getProducts}
    sort={sort}
    setAllData={setAllData}
    allData={allData}
    setSort={setSort}
    />
    </>
  )
}
